import { type ReactNode } from 'react';
import { useAuth } from '@/hooks/use-auth';
import {
  usePendingRaceClaim,
  useAcknowledgeClaim,
} from '../hooks/use-race-bonus-claim';

function formatUSD(n: number): string {
  return '$' + n.toFixed(2).replace('.', ',');
}

type CardProps = { amount: number; threshold: number; onDismiss: () => void };

function PopupCard({ amount, threshold, onDismiss }: CardProps): ReactNode {
  return (
    <div className="mx-base max-w-[24rem] rounded-lg bg-surface-elevated p-xl text-center">
      <p className="text-[3rem] leading-none">{'\uD83C\uDFC6'}</p>
      <h2 className="mt-sm text-xl font-bold text-text-primary">
        {'\u00A1Has ganado el bonus de velocidad!'}
      </h2>
      <PopupBody amount={amount} threshold={threshold} />
      <button
        type="button"
        onClick={onDismiss}
        className="mt-lg w-full rounded-md bg-brand-red px-base py-sm font-medium text-white hover:bg-brand-coral"
      >
        Cerrar
      </button>
    </div>
  );
}

function PopupBody({
  amount,
  threshold,
}: {
  amount: number;
  threshold: number;
}): ReactNode {
  return (
    <>
      <p className="mt-xs text-text-secondary">
        Fuiste el primero en llegar a{' '}
        <span className="font-bold text-brand-red">{threshold}</span> creadores
        este ciclo.
      </p>
      <p className="mt-sm text-2xl font-bold text-success">
        +{formatUSD(amount)}
      </p>
    </>
  );
}

export function RaceBonusPopup(): ReactNode {
  const { user } = useAuth();
  const { data: claim } = usePendingRaceClaim(user?.id);
  const ack = useAcknowledgeClaim();

  if (!claim) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/60">
      <PopupCard
        amount={claim.amount_eur}
        threshold={claim.threshold}
        onDismiss={() => ack.mutate(claim.id)}
      />
    </div>
  );
}
